var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', [_vm._v("Parents")]), _vm._m(0), _c('br'), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-primary', {
    on: {
      "click": _vm.clickTest
    }
  }, [_c('u-icon', {
    staticClass: "v-icon--left"
  }, [_vm._v("favorite")]), _vm._v("버튼")], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-primary2', {
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-primary3', {
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-secondary', {
    attrs: {
      "x-large": ""
    },
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-secondary2', {
    attrs: {
      "x-large": ""
    },
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-secondary3', {
    attrs: {
      "x-large": ""
    },
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-tertiary', {
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼"), _c('u-icon', {
    staticClass: "v-icon--right"
  }, [_vm._v("check")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-tertiary2', {
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-tertiary3', {
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-quarternary', {
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-quarternary2', {
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-quarternary3', {
    on: {
      "click": _vm.clickTest
    }
  }, [_vm._v("버튼")])], 1)], 1), _c('v-divider', {
    staticClass: "my-30px"
  }), _c('h1', [_vm._v("Styles")]), _c('h2', [_vm._v("Flat")]), _vm._m(1), _c('br'), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('u-btn-flat-tile', [_vm._v("Flat Tile")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('u-btn-flat-rounded', [_vm._v("Flat Rounded")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('u-btn-flat-pill', [_vm._v("Flat Pill")])], 1)], 1), _c('br'), _c('h2', [_vm._v("Outlined")]), _vm._m(2), _c('br'), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('u-btn-outlined-tile', [_vm._v("Outlined Tile")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('u-btn-outlined-rounded', [_vm._v("Outlined Rounded")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('u-btn-outlined-pill', [_vm._v("Outlined Pill")])], 1)], 1), _c('v-divider', {
    staticClass: "my-30px"
  }), _c('h1', [_vm._v("Variant")]), _c('h3', [_vm._v("{variant} : (기본), elevation, outlined")]), _vm._m(3), _c('br'), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Default")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "elevation": "10",
      "color": "white"
    }
  }, [_vm._v("Elevation")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    }
  }, [_vm._v("Outlined")])], 1)], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('u', [_vm._v("btn-{parents}")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('u', [_vm._v("u-btn-flat-{}")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('u', [_vm._v("u-btn-outlined-{}")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('u', [_vm._v("{variant}")])]);

}]

export { render, staticRenderFns }